<template>
  <auth-layout
    :isLoading="isLoading"
    contentClass="pt-0"
    pageClass="lock-page"
    styleContent="min-height: auto"
  >
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <form method="POST" @submit.prevent="validateSubmit">
          <card class="card-login">
            <div slot="header" class="text-center">
              <img
                src="/static/img/Logo SmartCultivo.png"
                alt="Logo SmartCultivo"
                class="img-fluid"
              />
            </div>
            <!-- <div class="content"> -->
            <div class="user-profile">
              <div class="author">
                <span v-if="user_store">
                  <img
                    v-if="user_store.avatar"
                    class="avatar border-gray"
                    :src="user_store.avatar"
                    alt="..."
                  />
                  <img
                    v-else
                    class="avatar"
                    src="/static/img/avatar-dafult.svg"
                    alt="..."
                  />
                </span>
                <span v-else>
                  <span v-if="user_local">
                    <img
                      v-if="user_local.avatar"
                      class="avatar border-gray"
                      :src="user_local.avatar"
                      alt="..."
                    />
                    <img
                      v-else
                      class="avatar border-gray"
                      src="/static/img/avatar-dafult.svg"
                      alt="avatar"
                    />
                  </span>
                </span>
              </div>
              <h4 v-if="user_store" style="color: dimgray">
                {{ user_store.first_name }} {{ user_store.last_name }}
              </h4>
              <h4 v-else-if="user_local">{{ user_local.name }}</h4>
              <fg-input class="hiddenfg"></fg-input>
              <fg-input
                :placeholder="$t('vie.Pag.Aut.Lock.enterPassword')"
                v-validate="modelValidations.password"
                name="common_words.password"
                :error="getError('common_words.password', true)"
                v-model="user.password"
                v-on:keyup="validateKey"
                :type="showPass.inputTypePass"
                :myCustom="{ addon: 'not-input-group-addon' }"
              >
                <template slot="addonRight">
                  <l-button @click="showPassword">
                    <em :class="showPass.iconBtnPass"></em>
                  </l-button>
                </template>
              </fg-input>
              <button type="submit" class="btn btn-round btn-info btn-wd">
                {{ $t('vie.Pag.Aut.Lock.unlock') }}
              </button>
              <button
                type="button"
                class="btn btn-round btn-danger btn-wd"
                @click.prevent="signout"
              >
                {{ $t('vie.Pag.Aut.Lock.signOut') }}
              </button>
            </div>
            <!-- </div> -->
          </card>
        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapActions, mapGetters } from 'vuex';
import { removeLocalStorage } from 'src/util/Util';
import i18n from 'src/i18n';
import Loading from 'vue-loading-overlay';
import mixinAuth from 'src/util/mixinAuth';
import MixinForm from 'src/mixins/forms/mixin-form';
import store from '@/store';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      user_local: null,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      user_store: 'auth/user',
    }),
  },
  mixins: [mixinAuth, MixinForm],
  methods: {
    ...mapActions({
      logout: 'auth/logout',
      cleanUserlogout: 'auth/cleanUserlogout',
      closeAllUserSessions: 'auth/closeAllUserSessions',
    }),

    validateSubmit() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.user.login = this.user_local.user;
          this.signin();
        }
      });
    },

    // este metodo se encagar de llamar nuestra accion login del store
    signin() {
      this.isLoading = true;
      this.user.lock = true;

      this.login(this.user)
        .then((response) => {
          localStorage.removeItem('user');
          let last_route = sessionStorage.getItem('urlModule');
          this.isLoading = false;
          this.$router.push(last_route ? last_route : '/').catch(() => {
            if (response.data.success == 200) {
              this.passRequestEmail({
                login: response.data.data,
                password_temporary: true,
              });
            }
          });
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response.data.message) {
            SweetAlert.danger(error.response.data.message);
          }
        });
    },

    signout() {
      this.isLoading = true;
      this.closeAllUserSessions({ login: store.state.auth.user.username }).then(
        () => {
          this.isLoading = false;
          this.cleanUserlogout();
          sessionStorage.clear();
          removeLocalStorage('locale');
          this.$router.push('/login');
        }
      );
    },
  },

  created() {
    if (localStorage.getItem('user')) {
      this.user_local = JSON.parse(localStorage.getItem('user'));
    }
  },

  mounted() {
    let downtime = localStorage.getItem('downtime');
    let mouseStopLock = null;
    document.addEventListener('mousemove', () => {
      clearTimeout(mouseStopLock);
      mouseStopLock = setTimeout(() => {
        if (
          this.$route.name != 'Login' &&
          this.$route.name != 'PasswordReset'
        ) {
          store
            .dispatch('auth/closeAllUserSessions', {
              login: store.state.auth.user.username,
            })
            .then(() => {
              store.dispatch('auth/cleanUserlogout');
              SweetAlert.warning(i18n.t('vie.Pag.Aut.Lock.inactiveAndBlocked'));
              localStorage.removeItem('user');
              localStorage.removeItem('token');
              clearTimeout(mouseStopLock);
              this.$router.push('/login').catch((e) => {
                console.log(e);
              });
            });
        }
      }, downtime * 60000);
    });
  },
};
</script>
<style>
.hiddenfg {
  display: none;
}
.invalid-feedback {
  background-color: white !important;
  padding: 10px;
}
</style>
